import script from "./testDialog.vue?vue&type=script&setup=true&lang=js"
export * from "./testDialog.vue?vue&type=script&setup=true&lang=js"

import "./testDialog.vue?vue&type=style&index=0&id=964a970e&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-964a970e"]])

export default __exports__